import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-modal-folder-item',
  templateUrl: './modal-folder-item.component.html',
  styleUrls: ['./modal-folder-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalFolderItemComponent implements OnInit {
  @Input() name!: string;
  constructor() { }

  ngOnInit(): void {
  }

}
